// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"InputFooter_footerWrapper__bA3K1","footerLeft":"InputFooter_footerLeft__TkXWv","infoIcon":"InputFooter_infoIcon__jXOHT","hint":"InputFooter_hint__h_Jez"};